import { BaseLayout } from "./baseLayout"
import { uoms_conversion, createWeightsDict, changeUom, modifyWeightSet, createAlgoInputs, processAlgoOutput } from "./commonUtils"
import Big from "big.js"
import { handleInterpolation, calculateUncertainty, get_sub_opt, get_trunc_opt} from "./report_utility"

export const BaseIso = {
    mixins: [BaseLayout],
    data() {
        return {
            tempWeights: null,
            precision: 0,
            primaries: [],
            conversion_factor: 0,
            currentPrimary: null,
            updated: true,
            // loading: false,
            myWorker: null
        }
    },
    watch: {
        measures: {
            deep: true,
            handler() {
                if (!this.preview) {
                    this.debouncedSave();
                }
            }
        },
    },
    methods: {
        updateTolerance() {
            this.updated = false
            this.buildTolerances()
            this.handleToleranceChange()
            this.updated = true
        },
        //phmter + thermometer methods
        calculateDiff(item) {
            console.log('calculateDiff ** before')
            if (item.reading != null && item.reading != '' && item.conv) {
                let range = this.calcMinRange(item.reading)
                let precision = this.currentPrecision
                if (range) {
                    precision = this.countDecimals(range.d)
                }
                item.difference = this.round(Big(item.reading).minus(item.conv), precision)
                item.toleranceError = this.handleToleranceError(item)
                item.result = !this.precision_overflow && Big(item.toleranceError).abs().lte(this.measures.tolerance) ? 'done' : 'failed'
                console.log('calculateDiff', item)
            } else {
                item.result = 'uncomplete'
            }
        },
        interpolateValue(item, families) {
            if (item.nom != null && item.nom != "" && item.primaryRead != null && item.primaryRead != "") {
                if (!this.checkPrimaryExists(this.currentPrimary)) {
                    this.currentPrimary = this.findPrimaryByFamily(families)
                }
                if (this.currentPrimary) {
                    let primaryData = this.currentPrimary.primary_data.data
                    console.log("$$ DEBUG before interpolation", primaryData)
                    let result = handleInterpolation(item.nom, primaryData)
                    console.log("$$ DEBUG result interpolation", result)
                    if (result != null) {
                        item.conv = this.round(Big(item.primaryRead).minus(result.error))
                        item.uncertain = this.round(this.calculateUncertainFull(item.primaryRead, result.uncertain, primaryData, this.measures.k), this.precision * 2)
                        this.calculateDiff(item)
                    }
                }
            }
        },
        calculateUncertainFull(value, interpolated_U, primaryData, k) {
            let range = this.calcMinRange(value)
            return calculateUncertainty(interpolated_U, primaryData, Big(range.d).times(2).toString(), k)
        },
        //end of ph + thermo methods
        checkPrimaryExists(item) {
            if (item) {
                return this.data.primaries.find(function(element) {
                    return element._id == item._id
                })
            }
            return false
        },
        openWeightSelection(nom, selected = []) {
            this.$refs.layoutBlock.openDialog(nom, this.data.primaries, this.instrument_data.uom, this.precision, selected)
        },
        openWeightSelected(items) {
            this.$refs.layoutBlock.openViewDialog(items, this.data.primaries, this.instrument_data.uom)
        },
        openConfirmDialog() {
            this.$refs.layoutBlock.openConfirm()
        },
        buildConversionFactor() {
            if (this.instrument_data) {
                let instr_uom = this.instrument_data.uom
                let weight_uom = 'g' //TODO change this in a field read
                this.conversion_factor = uoms_conversion[weight_uom][instr_uom]
                console.log("debug conversion factor: ", this.conversion_factor)
            }
        },
        handleConvValue(value) {
            return this.conversion_factor * value
        },
        handleInvalidPrimaries() {
            if (this.data.primaries && this.data.invalidPrimaries) {
                this.measures.items.forEach(item => {
                    item.conv = 0
                    item.primaryRead = 0
                    item.uncertain = 0
                    item.difference = 0 - item.reading
                })
            }
        },
        handleToleranceError(row) {
            if (this.measures.toleranceData.t_type && this.measures.toleranceData.t_type == "law") {
                return this.round(this.calc_OIML(this.calcMinRange(row.nom), row.nom))
            } else if (this.measures.toleranceData.t_calc) {
                switch (this.measures.toleranceData.t_calc) {
                    case "perc":
                        if (row.nom) {
                            return Big(row.difference).div(row.nom).times(100).abs().toFixed(2)
                        } else {
                            return Big(0).toFixed(0)
                        }
                    case "val":{
                        let range = this.calcMinRange(row.reading)
                        if (range) {
                            return Big(row.difference).div(range.d).abs().toFixed(0)
                        } else {
                            return Big(0).toFixed(0)
                        }
                    }
                    default:
                        break
                }
            } else {
                return Big(0).toFixed()
            }
        },
        autoFill(items) {
            for (let item of items) {
                if (item.conv) {
                    this.$set(item, 'reading', item.conv)
                        // item.reading = _.cloneDeep(item.conv)
                } else if (item.nom) {
                    this.$set(item, 'reading', item.nom)
                        // item.reading = _.cloneDeep(item.nom)
                } else {
                    this.$set(item, 'reading', "")
                        // item.reading = ""
                }
            }
        },
        autoFillWrapper(items){  //Wrapper for the Non-nawi instruments
            this.autoFill(items)
            for(let item of items){
                this.calculateDiff(item)
            }
        },
        prepareDict() {
            let tempDict = changeUom(_.cloneDeep(this.data.primaries), this.instrument_data.uom)
            modifyWeightSet(tempDict)
            return createWeightsDict(tempDict)
        },
        autoSelection(nom, w_dict = null) {
            if (nom) {
                let newDict = w_dict ? w_dict : this.prepareDict()
                let algoInputs = createAlgoInputs(newDict)
                let nNom = nom * Math.pow(10, algoInputs.decimals)
                let result = get_trunc_opt(nNom, algoInputs.arrVals)
                let k = processAlgoOutput(result, newDict, algoInputs.decimals)
                return k
            } 
        },
        async getImageID(){
            if(this.data.instrument_data.custom_data && this.data.instrument_data.custom_data.shape){
                let selector = {}
                if(this.data.block.name == "eccentricity_big"){
                    selector = {
                        doc_type: "imagepoint",
                        _id: "imagepoint:pesa_ponte"
                    }
                } else {
                    let points = this.data.block.conf.min_readings ? this.data.block.conf.min_readings : this.measures.points
                    selector = {
                        doc_type: "imagepoint",
                        shape: this.data.instrument_data.custom_data.shape,
                        points: points + ""
                    }
                }
                let search = await this.$store.state.$pouch.find("masters", {selector: selector})
                if (search && search.docs.length > 0){
                    this.measures.image_id = search.docs[0]._id
                }
            }
        },
    },
    computed: {
        addWarning() {
            if (this.measures.tolerance === "Non presente") {
                return 'warning'
            } else {
                return undefined
            }
        },
        computedStatus() {
            console.log("computed status", this.measures.result)
            let str = "NON COMPLETO"
            switch (this.measures.result) {
                case 'uncomplete':
                    str = "PROVA INCOMPLETA"
                    break
                case 'done':
                    str = "CONFORME"
                    break
                case 'failed':
                    str = "NON CONFORME"
                    break

            }

            return str
        },
        is_OIML() {
            if (this.measures.useTolerance && this.measures.toleranceData && this.measures.toleranceData.t_type) {
                return true
            } else {
                return false
            }
        }

    },

}